<template>
  <div class="trace-bg" >
  <div class="block">
      <h1>{{ $t('issueTrack.title', { msg: 'issueTrack.title' }) }}  {{ trace.title  }}</h1>
      <br>
 <div>
<h2>{{ $t('issueTrack.dialog', { msg: 'issueTrack.dialog' }) }} </h2>
<el-card class="duiHua-lan">
<el-form ref="recordForm" :model="recordForm" label-width="90px" :rules="rules">
  <el-form-item :label="$t('issueTrack.replyPerson', { msg: 'issueTrack.replyPerson' })" prop="receiver">
      <el-select v-model="recordForm.receiver" :placeholder="$t('issueTrack.crp', { msg: 'issueTrack.crp' })">
          <el-option
            v-for="account in userAccount"
            :key="account.id"
            :value="account.name"
            :label="account.name"
            />
       </el-select>
   </el-form-item>
   <el-form-item :label="$t('issueTrack.rc', { msg: 'issueTrack.rc' })" prop="contextResp">
       <!-- <el-input type="textarea" :autosize="{ minRows: 8, maxRows: 25}" v-model="recordForm.contextResp"></el-input> -->
       <div style="border: 1px solid #ccc;">
            <Toolbar
                style="border-bottom: 1px solid #ccc"
                :editor="editor"
                :defaultConfig="toolbarConfig"
                :mode="mode"
            />
            <Editor
                style="height: 280px; overflow-y: hidden;"
                v-model="recordForm.contextResp"
                :defaultConfig="editorConfig"
                :mode="mode"
                @onChange="onChange"
                @onCreated="onCreated"
               
            />
        </div>
   </el-form-item>
   <el-form-item :label="$t('issueTrack.uploadImage', { msg: 'issueTrack.uploadImage' })">
    
 <el-upload
 ref='upload'
 class="upload-demo"
 :action="uploadUrl"
 :on-preview="handlePreview"
 :on-remove="handleRemove"
 :file-list="fileList"
 :on-success="handleUploadSuccess"
 :on-change="handleChange"
 :before-upload="handleBeforeUpload"
 :multiple="true"
 >
 <el-button size="small" type="primary">{{ $t('issueTrack.uploadClick', { msg: 'issueTrack.uploadClick' }) }}</el-button>
 <!-- <div  class="el-upload__tip">{{ $t('issueTrack.uploadInfo', { msg: 'issueTrack.uploadInfo' }) }}</div> -->
 </el-upload>

   </el-form-item>
   <el-form-item :label="$t('issueTrack.em', { msg: 'issueTrack.em' })">
    <el-radio v-model="recordForm.isRemind" label="0">{{ $t('issueTrack.norm', { msg: 'issueTrack.norm' }) }}</el-radio>
    <el-radio v-model="recordForm.isRemind" label="1">{{ $t('issueTrack.rm', { msg: 'issueTrack.rm' }) }}</el-radio>
   </el-form-item>
   <el-form-item>
       <el-button size="mini" type="success" icon="el-icon-message" @click="onSubmit('recordForm')">{{ $t('issueTrack.sd', { msg: 'issueTrack.sd' }) }}</el-button>
       <el-button size="mini" @click="resetForm('recordForm')" type="danger">{{ $t('issueTrack.rs', { msg: 'issueTrack.rs' }) }}</el-button>
       <el-button
         size="mini"
         type="primary"
         icon="el-icon-s-promotion"
         style="padding-right: 10px"
         @click.stop="handleSkip()" round>{{ $t('issueTrack.home', { msg: 'issueTrack.home' }) }}</el-button>
   </el-form-item>
</el-form>
</el-card>
</div>

<el-timeline :reverse="false">
  <el-timeline-item 
  v-for="(record, index) in recordList"
    :key="index"
    :icon='el-icon-more'
    :type='primary'  
    :size='large'
    color="#0bbd87"
    :timestamp="record.createTime" placement="top">
    <el-card class="recordBar">
      <h4>
        {{ record.sender }} <span style="color:blue;font-size:15px;font-weight:bold">{{ $t('issueTrack.reply', { msg: 'issueTrack.reply' }) }} </span>@{{ record.receiver }}
        &nbsp;&nbsp;&nbsp;&nbsp;
        <el-badge :value="$t('issueTrack.alerted', { msg: 'issueTrack.alerted' })" class="item" v-show="record.isRemind==1">
        <el-tag type="success" size="mini">{{ $t('issueTrack.remind', { msg: 'issueTrack.remind' }) }}</el-tag>
        </el-badge>
      </h4>
      <!-- <p style="font-size:15px;color:black"> <span style="color:rgb(255, 187, 0);font-size:15px;font-weight:bold">{{ $t('issueTrack.content', { msg: 'issueTrack.content' }) }} </span>
        {{ record.issueResponse }}
      </p> -->
        <template #label><el-text style="font-size: 16px;">{{ $t('issueTrack.content', { msg: 'issueTrack.content' }) }}</el-text></template>
                <div style="border: 1px solid hsl(133, 36%, 95%);">
                  <Editor
                      style="height: auto; overflow-y: hidden;"
                      v-model="record.issueResponse"
                      :defaultConfig="responseEditorConfig"
                      :mode="mode"
                      @onCreated="onCreatedDispaly"
                  />
                  </div>   
      <!-- <p v-show="record.urlDTOList.length>0"><span class="demonstration"> {{ $t('issueTrack.issueImage', { msg: 'issueTrack.issueImage' }) }}</span> </p> -->
  <div class="block">
      <!-- <img v-for="item in record.urlDTOList" :key="item.id" :src="item.imageUrl" class="image-full"> -->
      <el-table :data="record.urlDTOList" v-loading="load" v-show="record.urlDTOList.length>0">
        <el-table-column property="imageName" :label="$t('issue.table.fileName', { msg: 'issue.table.fileName' })"></el-table-column>
        <el-table-column property="imageUrl" :label="$t('issue.table.path', { msg: 'issue.table.path' })" ></el-table-column>
        <el-table-column :label="$t('issue.table.opr', { msg: 'issue.table.opr' })">
        <template #default="scope">
        <el-button
            size="mini"
            type="success"
            @click="handleLoad(scope.$index, scope.row.imageUrl)">{{ $t('issue.table.download', { msg: 'issue.table.download' }) }}</el-button>
       </template>
        </el-table-column>
        </el-table> 
 </div>
    </el-card>
  </el-timeline-item>
</el-timeline>
</div>

</div>
</template>
<script>
import { baseUrl_New } from '../../axios/urlconfig';
import axios from 'axios';
import { Editor, Toolbar } from '@wangeditor/editor-for-vue'
import { i18nChangeLanguage } from '@wangeditor/editor';

  export default {
    components: { Editor, Toolbar },
    data() {
      return {
        trace:{
          title:this.$route.params.title,
          issueId:this.$route.params.issueId,
        },
      issueTransmits: [{
        solution: '支持使用图标1111111111111',
        responser: 'oscar',
        createdTime: '2018-04-12 20:46',
      },{
        solution: '支持使用图标222222222222',
        responser: 'zhaofei',
        createdTime: '2018-04-15 20:46',
      },{
        solution: '支持使用图标333333333333',
        responser: 'oscar',
        createdTime: '2018-04-18 20:46',
      },{
        solution: '支持使用图标4444444444444',
        responser: 'zhaofei',
        createdTime: '2018-04-19 20:46',
      },{
        solution: '支持使用图标55555555555',
        responser: 'oscar',
        createdTime: '2018-04-21 20:46',
      }], 
      rules:{
        receiver: [
          { required: true, message: this.$t('issueTrack.crp', { msg: 'issueTrack.crp' }), trigger: 'change' }
        ],
        contextResp: [
          { required: true, message: this.$t('issueTrack.responseText', { msg: 'issueTrack.responseText' }), trigger: 'blur' }
        ],
      },
      recordForm:{
        receiver:'',
        email:'',
        contextResp:"",
        isRemind:'0',
        stringUrl:[],
      },
      userAccount:[],
      recordCard:[{
        id:'',
        sender:'',
        receiver:'',
        issueResponse:'',
        createTime:'',
      }],
      imgList: [
              {id:0,idView:'https://srb-data.oss-cn-beijing.aliyuncs.com/resFile/2023/12/08/120801.png'},
              {id:1,idView:'https://srb-data.oss-cn-beijing.aliyuncs.com/resFile/2023/12/06/help-right.png'}          
          ],
      uploadUrl: baseUrl_New + "/oss/file/uploadFile",//图片上传
      fileList:[],
      imageUrl:'',
      imageUrlList:[],
      recordId:'',
      recordList:[{
        "id":'',
        sender:'',
        receiver:'',
        issueResponse:'',
        isRemind:'',
        createTime:'',
        urlDTOList:[
          {
            id:'',
            imageName:'',
            imageUrl:'',
          }
        ],
      }],
      //富文本编辑
      editor: null,
          html: '',
          toolbarConfig: {
          // showLinkImg: false,
          //uploadImgShowBase64: false,
	        excludeKeys: [  //删除工具栏的插件
	          'insertVideo', // 删除视频
	          'uploadVideo',
	          'group-video',
	          //'insertImage',// 删除网络图片上传
	          'insertLink',// 删除链接
	          'codeBlock',// 删除代码块
            "emotion", //表情
            //"uploadImage",//删除图片
            //"insertTable", // 插入表格删除
	        ]
          },
          editorConfig: {
             placeholder: this.$t('issue.issueD', { msg: 'issue.issueD' }),
             readOnly: false, // 是否只允许阅读，不可编辑
		         //autoFocus: true,
             MENU_CONF: {
		          // 配置上传图片,只允许base64上传
		          uploadImage: {
		            server: baseUrl_New+'/oss/file/uploadEditor', // 上传接口
                fieldName: 'file',
		            allowedFileTypes: ['image/*'],
		            maxFileSize: 1 * 1024 * 1024, // 1M
		           // base64LimitSize: 1 * 1024 * 1024, // 1g 以下插入 base64
               // 将 meta 拼接到 url 参数中，默认 false
               // metaWithUrl: false,
              onSuccess(file, res) {          // JS 语法
                  console.log(`${file.name} 上传成功`, res)
              },

                // 自定义上传
             // customInsert(res, insertFn) {
              //insertFn(res[0].url); //同步插入,顺序不会乱
            //  },
                            
		            onError: (file, err, res) => {
		             this.$message.warning('当前选择的图片过大！请选择1M以内')
		            },
		          },
		     }  
         
          },
          mode: 'default', // or 'simple', 
          responseEditorConfig:{
            placeholder: '请输入内容...',
             readOnly: true, // 是否只允许阅读，不可编辑
          },
          responseEditor:null,


      };
    },

    created(){
     this.getAccountAll();
     this.getCardAllissueId();
    },

    beforeUnmount() {
        const editor = this.editor
        if (editor == null) return
        editor.destroy() // 组件销毁时，及时销毁编辑器
      },

    methods: {
      handleSkip(){
  this.$router.push({
    path:'/issue',
   });
   }, 
   onSubmit(formName) { //发送回复
      //console.log('submit!');
      this.$refs[formName].validate((valid) => {
        if (valid) {

      var that = this
      axios.post(baseUrl_New + '/email/record',{
        title:this.trace.title,
        issueId:this.trace.issueId,
        receiver:this.recordForm.receiver,
        issueResponse:this.recordForm.contextResp,
        isRemind:this.recordForm.isRemind,
        stringUrl:this.recordForm.stringUrl,
      }).then(resp=>{
        if(resp.data.data.record==0){
          this.$message.success(this.$t('issueTrack.emailAccountMsg', { msg: 'issueTrack.emailAccountMsg' }));
          this.resetForm('recordForm');
          this.getCardAllissueId();
          this.$refs.upload.clearFiles();  //清空图片
          this.recordForm.stringUrl=[];
        }else{
        this.$message.success(this.$t('issueTrack.successMsg', { msg: 'issueTrack.successMsg' }));
        this.resetForm('recordForm');
        this.getCardAllissueId();
        this.$refs.upload.clearFiles();  //清空图片
        this.recordForm.stringUrl=[];
      }
      }).catch(err => {
        this.$message.error(this.$t('issueTrack.errMsg', { msg: 'issueTrack.errMsg' }))
      })
        } else {
          return false;
        }
      });    
    }, 
    getAccountAll(){
        axios.get(baseUrl_New+'/email/getEmailAccountList/'+this.trace.issueId,).then(response=>{
          let resultMap = response.data;
          this.userAccount=resultMap.list;
        })
      },
      //卡片中的问题追踪
     
    resetForm(form) {  //重置对话栏
      this.$refs[form].resetFields();
      this.recordForm.isRemind='0';
      this.recordForm.stringUrl=[];
      this.$refs.upload.clearFiles();  //清空图片
    },

    handleRemove(file, fileList) {
      console.log(file, fileList);
    },
    handlePreview(file) {
      console.log(file);
    },
    handleUploadSuccess(res, file, fileList){ //成功之后把值 传给stringUrl[]
      this.recordForm.stringUrl.push(res.data.fileUrl);

  },
  handleChange(file, fileList) {
  //  this.recordForm.stringUrl=fileList.response.data;
    },
    //卡片所有回复信息
    getCardAllissueId(){
      axios.get(baseUrl_New+'/email/getCardAll/'+this.trace.issueId,
      ).then(response=>{
        // console.log(response);
         this.recordList= response.data.list;

        })
    },
    // 限制图片大小
  handleBeforeUpload(file) {
  
  const isLt8M = file.size / 1024 / 1024 < 8;

  if (!isLt8M) {
      this.$message.error(this.$t('issueTrack.uploadInfo', { msg: 'issueTrack.uploadInfo' }));
  }
  return isLt8M
},
  //wangeditor编辑器
  onCreated(editor) {
            this.editor = Object.seal(editor) // 一定要用 Object.seal() ，否则会报错
            i18nChangeLanguage(localStorage.getItem('language')); //编辑框国际化
        },
  onChange(editor) {
      console.log("onChange", editor.getHtml()); // onChange 时获取编辑器最新内容
       },
  onCreatedDispaly(responseEditor){
    this.responseEditor = Object.seal(responseEditor)
  },
     //文件下载
     handleLoad(index, fileUrl) {
    axios.get(baseUrl_New + '/oss/file/downloadFile?fileUrl=' + fileUrl, {
    responseType: 'blob',
    headers: {
      'Content-Type': 'application/octet-stream'
    }
  }).then(response => {
    const url = window.URL.createObjectURL(new Blob([response.data]));
    const link = document.createElement('a');
    link.href = url;
    const filename = fileUrl.substring(fileUrl.lastIndexOf('/') + 1);
    link.setAttribute('download', filename);
    document.body.appendChild(link);
    link.click();
  }).catch(
    (error)=>{
      this.$message.error(this.$t('issue.issueInfoFile', { msg: 'issue.issueInfoFile' }))
    }
  );
},



    }
  };
</script>

<style src="@wangeditor/editor/dist/css/style.css"></style>
<style>

.image-full{
max-width: auto;
max-height: auto;
}
.demonstration{
color: rgb(13, 2, 24);
font: 1em sans-serif;
}
.el-upload__tip{
  color: rgb(170, 243, 152);
}
.trace-bg{
  background-image: url('https://srb-data.oss-cn-beijing.aliyuncs.com/resFile/2023/12/22/0101.png');
}
.trace-bg1{
  background-color: hsl(136, 12%, 83%);
}
.duiHua-lan{
  width: 100%;
  
}
.recordBar{
  width: 98%;
}
.item {
  margin-top: 10px;
  margin-right: 40px;
}
</style>